import { observer } from 'mobx-react';
import { FC } from 'react';

import { Button, Flex } from '@servicetitan/anvil2';
import IconOpenInNew from '@servicetitan/anvil2/assets/icons/material/round/open_in_new.svg';
import { useDependencies } from '@servicetitan/react-ioc';

// import { App as WFApp, OpenWebUrlTarget } from '@servicetitan/web-feature-app-service';
import { App as WFApp, OpenWebUrlTarget } from '@servicetitan/web-feature-app-service';

import { MessageType } from '../../common/models/message-type.model';
import { AppSettingsStore } from '../../common/stores/app-settings.store';
import { ChatStore } from '../../common/stores/chat.store';
import { MainStore } from '../../common/stores/main.store';
import { getDeeplinkHost } from '../../common/utils/get-deeplink-host';
import { ReplacementPartFinderStore } from '../stores/replacement-part-finder.store';

export const ViewEstimate: FC = observer(() => {
    const [chatStore, replacementPartFinderStore, appSettingsStore, mainStore] = useDependencies<
        [ChatStore, ReplacementPartFinderStore, AppSettingsStore, MainStore]
    >(ChatStore, ReplacementPartFinderStore, AppSettingsStore, MainStore);

    const handleViewEstimateButtonClick = () => {
        const appointmentId = mainStore.selectedAppointment?.id ?? 0;
        if (appSettingsStore.openedFromCordova) {
            window.location.href = '/close-to-estimate';
        } else {
            WFApp.openWebUrl({
                url: `${getDeeplinkHost()}/fma/appointments/${appointmentId}/estimates`,
                target: OpenWebUrlTarget.Navigation,
            });
        }
    };
    const handleFindPartButtonClick = () => {
        replacementPartFinderStore.showPartSelection();
        chatStore.enqueueMessages([
            {
                isMine: false,
                showBubble: false,
                showAvatar: false,
                date: new Date(),
                type: MessageType.CustomView,
                getView: () => (
                    <Button
                        size="small"
                        onClick={() => {
                            replacementPartFinderStore.showSelectEquipment();
                        }}
                    >
                        Change Equipment Selection
                    </Button>
                ),
            },
        ]);
    };

    return (
        <Flex gap="2">
            {appSettingsStore.canShowViewButtons && (
                <Button
                    onClick={handleViewEstimateButtonClick}
                    size="small"
                    appearance="primary"
                    icon={{
                        after: IconOpenInNew,
                    }}
                >
                    View Estimate
                </Button>
            )}

            <Button size="small" onClick={handleFindPartButtonClick}>
                Find Another Part
            </Button>
        </Flex>
    );
});
